import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./content.lazy.module').then((module) => module.ContentLazyModule);

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

export const contentLazyImports: ComponentNameAndModule[] = [
  defineImport('FaqSection'),
  defineImport('FourTopTasksSection'),
  defineImport('Hero'),
  defineImport('HeroMinimal'),
  defineImport('HeroWithAppButtons'),
  defineImport('HeroWithAsset'),
  defineImport('HeroWithWidget'),
  defineImport('InformationCard2Section'),
  defineImport('InformationCard3Section'),
  defineImport('InformationCard4Section'),
  defineImport('LinkList2Section'),
  defineImport('LinkList3Section'),
  defineImport('LinkList6Section'),
  defineImport('NotificationSection'),
  defineImport('TextDefault'),
  defineImport('TextImageAppSection'),
  defineImport('TextImageSection'),
  defineImport('TextWithCallToActionButton'),
  defineImport('TextWithAppStoreButtons'),
  defineImport('ThreeTopTasksSection'),
  defineImport('VideoSection'),
  defineImport('ProductCard2Section'),
  defineImport('ProductCard3Section'),
];
